import React from 'react';

import CAMPANA from '../../../assets/swiss-medical-center/centro_campana.jpg';
import Image from '../../Commons/Image/Image';

import styles from './SwissMedicalCampana.module.scss';

const SwissMedicalCampana = () => {
  return (
    <div className={styles.swiss_medical_campana}>
      <h3>Campana</h3>
      <p>
        <strong className={styles.swiss_medical_campana__redText}>Dirección:</strong> Colón 257,
        Campana
      </p>
      <p>
        <strong className={styles.swiss_medical_campana__redText}>Horarios:</strong> Lunes a viernes
        de 8 a 20 hs. Sábados de 8 a 14 hs.
      </p>
      <p>
        <strong className={styles.swiss_medical_campana__redText}>Turnos:</strong> 0810-333-8876
      </p>
      <Image
        src={CAMPANA}
        alt='Sede Campana'
        title='Campana'
        classes={styles.swiss_medical_campana__image}
      />
      <p>
        <strong className={styles.swiss_medical_campana__redText}>Especialidades medicas</strong>
      </p>
      <ul>
        <li>Cardiología</li>
        <li>Cirugía general</li>
        <li>Cirugía plástica</li>
        <li>Clínica médica</li>
        <li>Dermatología</li>
        <li>Dietista</li>
        <li>Ecografía general</li>
        <li>Flebología</li>
        <li>Ginecología</li>
        <li>Mastología</li>
        <li>Neurología</li>
        <li>Oftalmología</li>
        <li>Otorrinolaringología</li>
        <li>Pediatría</li>
        <li>Traumatología</li>
        <li>Urología</li>
      </ul>
      <p>
        <strong className={styles.swiss_medical_campana__redText}>Diagnóstico por imágenes</strong>
      </p>
      <ul>
        <li>Resonancia magnética</li>
        <li>Radiología simple</li>
        <li>Radiología odontológica</li>
        <li>Tomografía computada</li>
        <li>Tomografía odontológica</li>
      </ul>
      <p>
        <strong className={styles.swiss_medical_campana__redText}>Servicio de kinesiología</strong>
      </p>
      <ul>
        <li>Kinesiología</li>
        <li>Fisiatría</li>
      </ul>
    </div>
  );
};

export default SwissMedicalCampana;
